/**
 * XLM - Innovation & Technology | João Rodrigues | v2.0 | 2026*
 * 
 * Botões de saída com confirmação:
 * - Substituição de confirm() síncrono (bloqueia thread principal e GC) por modal assíncrono useAsyncConfirm
 * - ExitButton: confirmação antes de fechar ficheiro com alterações não guardadas
 * - ForceExitButton: confirmação antes de interromper Worker do Tesseract
 * - await permite que o browser liberte recursos antes de interromper processos pesados
 */

import { UserFile } from "../types/UserFile";
import { Button } from "./BootstrapIcons";
import { useSave } from "./uses";
import { useAsyncConfirm } from "../util/useAsyncConfirm";


export function ExitButton({file, setUserFile}: {file: UserFile, setUserFile: (f: UserFile | undefined) => void}){
    const { askUser, ConfirmComponent } = useAsyncConfirm();
    let saved = useSave(file);
    
    const handleExit = async() => {
        if(saved || await askUser("Trabalho não será guardado no browser. Sair?")){
            setUserFile(undefined);
        }
    };
    return (
        <>
            <Button 
                className="btn red-link fw-bold m-1 p-1" 
                onClick={handleExit}
                i="arrow-left" 
                title="Fechar ficheiro"
            />
            {ConfirmComponent}
        </>
    );
}


export function ForceExitButton({setUserFile}: {setUserFile: (f: undefined) => void}){
    const { askUser,ConfirmComponent } = useAsyncConfirm();

    const handleForceExit = async () => {
        if (await askUser("A anonimização automática será parada. Sair?")) {
            setUserFile(undefined);
        }
    };

    return (
        <>
            <Button 
                className="btn red-link fw-bold m-1 p-1" 
                onClick={handleForceExit} 
                i="arrow-left" 
                title="Fechar ficheiro"
            />
            {ConfirmComponent}
        </>
    );
    
    
}
